// extracted by mini-css-extract-plugin
export var collapsedSummary = "_rf-0";